import React from 'react';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {useRequiredStore} from "../../utils/store";
import {RootStoreContext} from "../../stores/root/root.store";

type Props = {
    dateString: string,
    showTime?: boolean,
    withSeconds?: boolean
};

const Date: React.FC<Props> = ({dateString, showTime, withSeconds}) => {

    const {authStore: {lz}} = useRequiredStore(RootStoreContext)

    if (!dateString) {
        return <>-</>;
    }

    const getTimezone = (): string => {
        dayjs.extend(utc)
        dayjs.extend(timezone)
        let format = showTime ? "DD-MM-YYYY HH:mm" : "DD-MM-YYYY";
        if (showTime && withSeconds) {
            format = format + ":ss";
        }
//        return dayjs.tz(dayjs(dateString), lz.tz).format(format);
        return dayjs(dateString).format(format);
    }
    return (
        <span style={{whiteSpace: "pre"}}>
            {getTimezone()}
        </span>
    );
}

export default Date;
